import React from "react";
import styles from "./sideMenu.module.scss";
import Typography from "../../reusableComponent/typography/Typography";

type DropdownOption = {
  label: string;
  value: string;
};

type DropdownProps = {
  icon?: string | React.ElementType;
  label?: string;
  options?: DropdownOption[];
  isSelected?: boolean;
  onSelect?: (value: string) => void;
  isDesktopSidebarExpand?: boolean;
  iconWidth?: any;
};

const SideMenuDropDown: React.FC<DropdownProps> = ({
  icon,
  label,
  onSelect,
  iconWidth = "24",
  isSelected = false,
}) => {
  const IconComp = (typeof icon === "string" ? null : icon) as React.ComponentType<any> | null;

  return (
    <button
      type="button"
      onClick={() => onSelect && onSelect(label || "")}
      className={`${styles.railItem} ${isSelected ? styles.selected : ""}`}
      aria-label={label}
      aria-current={isSelected ? "page" : undefined}
    >
      <span className={styles.railIcon}>
        {typeof icon === "string" ? (
          <img src={icon} alt="" className={styles.leftIcon} style={{ width: `${iconWidth}px` }} />
        ) : IconComp ? (
          <IconComp className={styles.muiIcon} sx={{ fontSize: 24 }} />
        ) : null}
      </span>
      {label && (
        <Typography
          variant="span"
          size="size12"
          weight={400}
          color={isSelected ? "brandPrimary" : "neutralDarkest"}
          className={styles.railLabel}
        >
          {label}
        </Typography>
      )}
    </button>
  );
};

export default SideMenuDropDown;
